
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import TextOptionTile from "../../../common/TextOptionTile";
import CustomButton from "../../../common/CustomButton";

function SlideSelectConsistency(props) {
    const cons = ["Stay Consistent", "Be More Active"];
    const [selectedCons, setSelectedCons] = useState("");

    const updateOptions = (m) => {
        setSelectedCons(m)
    }

    useEffect(() => {
        setSelectedCons(props?.preRegistrationDetails?.consistency || "");
    }, [props?.preRegistrationDetails]);

    let disable = selectedCons === "";

    return (
        <div id="uo-consistency" className="uo-component div-45-55">
            <div id="uo-c-banner">
                {/* <svg id="uo-c-polygon" width="1069" height="100%" viewBox="0 0 1069 648" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.7221 0.470698C1.41402 0.175195 -11.2637 39.0695 13.3967 56.6914L832.092 641.717C849.134 653.894 873.098 646.016 879.589 626.101L1067.08 50.8868C1073.58 30.9722 1058.86 10.4852 1037.91 10.281L31.7221 0.470698Z" fill="url(#paint0_linear_58_109)" />
                    <defs>
                        <linearGradient id="paint0_linear_58_109" x1="750.063" y1="-153.012" x2="503.305" y2="604.012" gradientUnits="userSpaceOnUse">
                            <stop offset="1" stop-color="#8B1E3F" />
                        </linearGradient>
                    </defs>
                </svg> */}
                <img src="/assets/images/onboarding/onboarding-consistency-banner.png" className="pi-banner" />


            </div>
            <div id="uo-c-inputs" className="bottom-text-area">
                <h4>You’re currently exercising {props?.preRegistrationDetails?.minutesPerWeek?.replace(" Mins", "")} minutes per week.</h4>
                <h6>Would you like to stay consistent, or are you looking to be more active?</h6>

                <div id="uo-cons-tiles">
                    {
                        cons.map((c, index) => {
                            return <TextOptionTile key={index} label={c} onClick={updateOptions} isActive={selectedCons == c} />
                        })
                    }
                </div>

                <CustomButton disabled={disable} className="uo-button active" onClick={() => {
                    props.moveNext();
                    props.setPreRegistrationDetails(prd => ({
                        ...prd,
                        consistency: selectedCons
                    }));
                }}>Continue</CustomButton>

            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({

});

export default connect(mapStateToProps, {
})(SlideSelectConsistency);
